import React from 'react';
import { BlocksService } from './blocks_service';
import { ProjectLoadErrorDialog } from './editor/error_dialogs';
import { LoadingPage, RedirectOnLoad } from './login_wall';

export function LegacyEditorRedirect({
  projectId,
  blocksService,
}: {
  projectId: string;
  blocksService: BlocksService;
}) {
  const [error, setError] = React.useState<unknown>(null);
  const [token, setToken] = React.useState<string | null>(null);
  React.useEffect(() => {
    blocksService
      .legacyGetTokenForId({ projectId })
      .then((res) => setToken(res.token))
      .catch((error) => setError(error));
  }, [projectId, blocksService]);

  if (error) {
    return <ProjectLoadErrorDialog error={error} />;
  } else if (token) {
    return <RedirectOnLoad name="editor" url={`/app/project/${token}`} />;
  } else {
    return <LoadingPage />;
  }
}
